import { all } from 'redux-saga/effects'

import settingSaga from './common/setting.Saga'
import userSaga from './common/user.Saga'
import watchNotification from './common/notification.Saga'
import watchAudit from './common/audit.Saga'
import commonAppSaga from './common/commonApp.Saga'
import nhanSuSaga from './nhanSu.Saga'
import bangLuongSaga from './bangLuong.Saga'
import chamCongSaga from './chamCong.Saga'
import donTuSaga from './donTu.Saga'
import hanhChinhSaga from './hanhChinh.Saga'
import mangXaHoiSaga from './mangXaHoi.Saga'
import tuyenDungSaga from './tuyenDung.Saga'

export default function* rootSaga() {
  yield all([
    settingSaga(),
    userSaga(),
    watchNotification(),
    watchAudit(),
    commonAppSaga(),
    nhanSuSaga(),
    bangLuongSaga(),
    chamCongSaga(),
    donTuSaga(),
    hanhChinhSaga(),
    mangXaHoiSaga(),
    tuyenDungSaga(),
  ])
}

